import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import TagInput from '../TagInput/TagInput';
import Application from '../Application/Application';

export default class TagInputExample extends Component {

  state = {
    placeholder: 'Enter tag name or any text',
    options: ['one', 'two', 'three', 'ten', 'thirty', 'these', 'are', 'the', 'selected', 'tags', 'tag with spaces (delimiter must not be space)'],
    value: '#one #two #three',
  };

  onChange = e => this.setState({ value: e.target.value });

  onChangeProps = e => this.setState(e.target.value);

  onUnlock = e => {
    window.showAppInfo('unlock icon');
    Application.showWarningDialog(
      'Unlock critical fields?',
      'This will unlock all critical fields and make them editable.',
      'Unlock', 'No', null,
      e => {
        this.setState({ locked: !this.state.locked });
      }
    );
  };

  repaint = () => this.forceUpdate();

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={TagInput.defaultProps} propTypes={TagInput.propTypes} propValues={this.state} onChange={this.onChangeProps}>
          <Tip>Try setting the <em>className</em> to <span className="string">fixed-columns-test</span> to make <code>TagInput</code> have 5 columns.</Tip>
          <Tip>Try setting the delimiter to &quot;, &quot; and clear the value to add support for spaces in tags.</Tip>
        </Properties>
        <TagInput {...this.state} onChange={this.onChange} options={this.state.options} onBlur={this.repaint} onFocus={this.repaint} onUnlock={this.onUnlock}/>
        <p>Value: <strong>{this.state.value}</strong></p>
        <SourceCode querySelector=".tag-input-example .core-tag-input"/>
      </Example>
    );
  }

}
